// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 5px;
  padding: 5px;
  display: block;
}

.price {
  font-family: AppFontSemiBold;
  font-size: 16px;
  line-height: 128%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  text-align: end;
}

ion-label {
  font-family: AppFontSemiBold;
  font-size: 16px;
  line-height: 128%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

ion-item {
  background: #ffffff;
  border-radius: 5px;
  margin-top: 10px;
  border-top: 0.5px solid #c0c0bf;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1019607843);
}

.pfand {
  font-size: 10px;
}

ion-checkbox {
  --color: #050b05;
  --ion-color-contrast: #fff !important;
  --border-color: #050b05;
  --border-color-checked: #050b05;
  --background-checked: #fff;
  --color-checked: #050b05;
  --checkbox-background-checked: #050b05;
  --checkmark-color: #fff;
}

ion-icon {
  display: inline-block;
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
  vertical-align: sub;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-checkbox/article-option-group-checkbox.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACD;;AAEA;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,eAAA;AAAD;;AAGA;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AAAD;;AAGA;EACC,+BAAA;EACA,YAAA;EACA,WAAA;AAAD;;AAGA;EACC,qBAAA;AAAD;;AAEA;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,uDAAA;AACD;;AAEA;EACC,eAAA;AACD;;AAEA;EACC,gBAAA;EACA,qCAAA;EAEA,uBAAA;EACA,+BAAA;EACA,0BAAA;EACA,wBAAA;EAEA,sCAAA;EACA,uBAAA;AADD;;AAGA;EACC,qBAAA;EACA,+BAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAAD","sourcesContent":["ion-radio-group {\n\twidth: 100%;\n\tborder-radius: 5px;\n\tpadding: 5px;\n\tdisplay: block;\n}\n\n.price {\n\tfont-family: AppFontSemiBold;\n\tfont-size: 16px;\n\tline-height: 128%;\n\tletter-spacing: 0;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\n\ttext-align: end;\n}\n\nion-label {\n\tfont-family: AppFontSemiBold;\n\tfont-size: 16px;\n\tline-height: 128%;\n\tletter-spacing: 0;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n}\n\nion-icon {\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\nion-item {\n\tbackground: #ffffff;\n\tborder-radius: 5px;\n\tmargin-top: 10px;\n\tborder-top: 0.5px solid #c0c0bf;\n\tbox-shadow: 0px 2px 8px 0px #0000001a;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n\nion-checkbox {\n\t--color: #050b05;\n\t--ion-color-contrast: #fff !important;\n\n\t--border-color: #050b05;\n\t--border-color-checked: #050b05;\n\t--background-checked: #fff;\n\t--color-checked: #050b05;\n\n\t--checkbox-background-checked: #050b05;\n\t--checkmark-color: #fff;\n}\nion-icon {\n\tdisplay: inline-block;\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n\tvertical-align: sub;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
